import { api } from '@/utils/api'

export interface UserProfile {
  ID: string
  availableCredits?: number
  availableAnalytics?: number
  history?: any[]
  lastUpdated?: number
  instagramUsername?: string
  instagramAnalytics?: Record<string, any>
  CompetitorList?: string
}

export interface UserProfileResponse {
  success: boolean
  profile?: UserProfile | null
  message?: string
}

export interface UpsertUserProfileRequest {
  instagramUsername?: string
  instagramAnalytics?: Record<string, any>
  availableCredits?: number
  history?: any[]
  CompetitorList?: string
}

class UserService {
  private baseUrl = '/v0_1/user'

  async getProfile(): Promise<UserProfileResponse> {
    return api.get(`${this.baseUrl}/profile`)
  }

  async upsertProfile(payload: UpsertUserProfileRequest): Promise<UserProfileResponse> {
    return api.post(`${this.baseUrl}/profile`, payload)
  }

  async setCompetitorList(watchlistId: string): Promise<{ success: boolean; message: string; profile: UserProfile }> {
    return api.post(`${this.baseUrl}/profile/competitor-list`, { CompetitorList: watchlistId })
  }

  async setInstagramUsername(username: string): Promise<{ success: boolean; message: string; profile: UserProfile }> {
    return api.post(`${this.baseUrl}/profile/instagram-username`, { instagramUsername: username })
  }

  async getAvailableAnalytics(): Promise<{ availableAnalytics: number }> {
    return api.get(`${this.baseUrl}/available-analytics`)
  }
}

export const userService = new UserService()


